{
    "up.common.cancel": "Cancel",
    "up.common.confirm": "Confirm",
    "up.common.start": "Start",
    "up.common.end": "End",
    "up.common.stop": "Stop",
    "up.common.copy": "Copy",
    "up.common.none": "None",
    "up.common.tip": "Tip",
    "up.common.success": "Success",
    "up.common.fail": "Fail",
    "up.common.close": "Close",
    "up.common.preview": "Preview",
    "up.common.re-select": "Re-select",
    "up.common.rotate": "Rotate",
    "up.common.pleaseChoose": "Please choose",
    "up.common.loading": "Loading",
    "up.common.loading2": "Loading",
    "up.common.inOperation": "In operation",
    "up.common.settings": "Settings",
    "up.common.retry": "Retry",
    "up.common.search": "Search",
    "up.common.more": "More",
    "up.common.video": "Video",
    "up.common.file": "File",
    "up.week.one": "Mon",
    "up.week.two": "Tue",
    "up.week.three": "Wed",
    "up.week.four": "Thu",
    "up.week.five": "Fri",
    "up.week.six": "Sat",
    "up.week.seven": "Sun",
    "up.barcode.error": "Failed to generate barcode",
    "up.calendar.chooseDates": "Date selection",
    "up.calendar.disabled": "This date is disabled",
    "up.calendar.daysExceed": "The number of selected days cannot exceed {days} days",
    "up.cityLocate.locateCity": "Locate city",
    "up.cityLocate.fail": "Location failed, please click to retry.",
    "up.cityLocate.locating": "Locating",
    "up.code.send": "Get verification code",
    "up.code.resendAfter": "Resend after X seconds",
    "up.code.resend": "Resend",
    "up.cropper.emptyWidhtOrHeight": "The width or height of the cropping box is not set",
    "up.empty.car": "Shopping cart is empty",
    "up.empty.page": "Page not found",
    "up.empty.search": "No search results",
    "up.empty.address": "No shipping address",
    "up.empty.wifi": "No WiFi",
    "up.empty.order": "Order is empty",
    "up.empty.coupon": "No coupons",
    "up.empty.favor": "No favorites",
    "up.empty.permission": "No permission",
    "up.empty.history": "No history",
    "up.empty.news": "No news list",
    "up.empty.message": "Message list is empty",
    "up.empty.list": "List is empty",
    "up.empty.data": "Data is empty",
    "up.empty.comment": "No comments",
    "up.link.copyed": "Link copied, please open in browser",
    "up.loadmoe.loadmore": "Load more",
    "up.loadmoe.nomore": "No more",
    "up.noNetwork.text": "Oops, network signal lost",
    "up.noNetwork.pleaseCheck": "Please check the network, or go to",
    "up.noNetwork.connect": "Network connected",
    "up.noNetwork.disconnect": "No network connection",
    "up.pagination.previous": "Previous",
    "up.pagination.next": "Next",
    "up.pullRefresh.pull": "Pull to refresh",
    "up.pullRefresh.release": "Release to refresh",
    "up.pullRefresh.refreshing": "Refreshing",
    "up.readMore.expand": "Expand to read more",
    "up.readMore.fold": "Collapse",
    "up.search.placeholder": "Please enter keywords",
    "up.signature.penSize": "Stroke size",
    "up.signature.penColor": "Stroke color",
    "up.upload.sizeExceed": "Size limit exceeded",
    "up.upload.uploading": "Uploading",
    "up.upload.previewImageFail": "Failed to preview image",
    "up.upload.previewVideoFail": "Failed to preview video",
    "up.goodsSku.stock": "Stock",
    "up.goodsSku.price": "Price",
    "up.goodsSku.amount": "Items",
    "up.goodsSku.choosed": "Selected",
    "up.goodsSku.buyAmount": "Quantity"
}